export default "__VITE_ASSET__GaIElRyD__"